import React, { useState, useEffect } from 'react';
import axios from 'axios';
import firebase from '../../Firebase/firebaseConnection';
import { useSettingsManager } from '../../Configuration/SettingsManager';
import { LogIn } from 'react-feather';
import Header from '../../Static/Header';
import Footer from "../../Static/Footer";
import logoNextStock from '../../img/Next Stock Logo.png';
import './Settings.css';
import DeleteAccountModal from './DeleteAccountModal';
import AppearanceSettings from './AppearanceSettings';

import { useTranslation } from "react-i18next";

import AlertManager from "../../Resources/AlertManager";
import NodeBackend from "../../Resources/NodeBackend";
const backend = new NodeBackend();
const API_ENDPOINT = backend.getPath();

export default function Contact({ setPage }) {

    const { t, i18n } = useTranslation();

    const { handleSettingsPress } = useSettingsManager();

    const [recipientEmail, setRecipientEmail] = useState('');
    const [recipientName, setRecipientName] = useState('');
    // const [nameJustUpdated, setNameJustUpdated] = useState(false);
    const [emailSubject, setEmailSubject] = useState('');
    const [nameId, setNameId] = useState('');
    const [emailMessage, setEmailMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [userName, setUserName] = useState('');

    const [showNameModal, setShowNameModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    useEffect(() => {
        let alive = true;
        const restore = async () => {
            const code = new URLSearchParams(window.location.search).get('deletion_request');
            if (!code) return;
            try {
                const user = firebase.auth().currentUser;
                if (!user) return;
                const token = await user.getIdToken(true);
                const response = await axios.get(API_ENDPOINT + 'delete-account/resume/' + encodeURIComponent(code), {headers:{Authorization:`Bearer ${token}`}});
                if (!alive) return;
                sessionStorage.setItem('nextstock:pending-account-deletion',JSON.stringify({uid:user.uid,email:response.data.email,reason:response.data.reason,typedEmail:response.data.email,pending:false}));
                const url = new URL(window.location.href);
                url.searchParams.delete('deletion_request');
                window.history.replaceState(null,'',url.pathname+url.search);
                setShowDeleteModal(true);
            } catch(e) {
                console.error('Could not resume account deletion:',e);
                sessionStorage.removeItem('nextstock:pending-account-deletion');
                const url = new URL(window.location.href);
                url.searchParams.delete('deletion_request');
                window.history.replaceState(null,'',url.pathname+url.search);
            }
        };
        const unsubscribe = firebase.auth().onAuthStateChanged(user => {if(user) restore();});
        return () => {alive=false;unsubscribe();};
    }, []);

    // --------------------------------------------------
    // Helper: navigate with URL sync (SPA style)
    // --------------------------------------------------
    const navigateTo = (pageName) => {
        setPage(pageName);
        const baseUrl = window.location.origin + window.location.pathname.split("?")[0];
        window.history.replaceState(null, "", `${baseUrl}?page=${pageName}`);
        window.scrollTo(0, 0);
    };

    useEffect(() => {
        const savedName = localStorage.getItem("userName");
        if (savedName) setUserName(savedName);
        setRecipientName(savedName || '');

        const userId = localStorage.getItem('userUid');
        const email = localStorage.getItem('userEmail');
        if (userId && email) {
            setRecipientEmail(email);
            setNameId(userId);
            setLoggedIn(true);
        }
    }, []);

    // useEffect(() => {
    //     if (!recipientName) return; // não anima quando está vazio (primeiro load)

    //     setNameJustUpdated(true);

    //     const timer = setTimeout(() => {
    //         setNameJustUpdated(false);
    //     }, 400); // duração da animação (ms)

    //     return () => clearTimeout(timer);
    // }, [recipientName]);

    // --------------------------------------------------
    // Reset Password
    // --------------------------------------------------
    async function ResetPasswordEmail() {
        if (!recipientEmail || !recipientEmail.includes("@")) {
            AlertManager.show({
                type: "warning", // "error", "warning", or "message"
                title: "Missing email address",
                message: "Please enter a valid email address.",
                buttonText: "Got it!"
            });
            return;
        }

        const isConfirmed = window.confirm(
            `Reset password?\n\nAre you sure you want to reset your password for:\n\n${recipientEmail}`
        );

        if (!isConfirmed) return;

        try {
            await firebase.auth().sendPasswordResetEmail(recipientEmail);
            AlertManager.show({
                type: "message", // "error", "warning", or "message"
                title: "Email sent",
                message: `We've sent a secure password reset link to \n\n${recipientEmail}\n\n... ` +
                `If it doesn't appear in your inbox shortly, please check your Spam, Junk, or Promotions folder.`,
                buttonText: "Close"
            });
        } catch (error) {
            AlertManager.show({
                type: "error", // "error", "warning", or "message"
                title: "Oops, something went wrong",
                message: error.message || "",
                buttonText: "Close"
            });
            console.log(error);
        }
    };

    // --------------------------------------------------
    // Send Contact Message
    // --------------------------------------------------
    async function sendMessage() {
        if (
            emailSubject.length < 3 ||
            emailMessage.length < 3 ||
            recipientEmail.length < 2 ||
            !recipientEmail.includes('@')
        ) {
            AlertManager.show({
                type: "warning", // "error", "warning", or "message"
                title: "All fields must be filled out",
                message: 'If they contain valid data, please review your email and message.',
                buttonText: "Close"
            });
            return;
        }

        try {
            const response = await axios.post(API_ENDPOINT + 'send-email-from-app', {
                name: nameId || '(guest user)',
                email: recipientEmail,
                subject: emailSubject,
                text: emailMessage
            });

            if (response.data.status === 'succeed') {
                setEmailSubject('');
                setEmailMessage('');
                setSuccess(true);
            } else {
                AlertManager.show({
                    type: "error", // "error", "warning", or "message"
                    title: "Sorry! Something went wrong",
                    message: 'Action failed. Please contact us at developer@nextstock.ca.',
                    buttonText: "Close"
                });
            }
        } catch (error) {
            console.error('Error sending email:', error);
            AlertManager.show({
                type: "error", // "error", "warning", or "message"
                title: "Sorry! Something went wrong",
                message: 'Action failed. Please contact us at developer@nextstock.ca.',
                buttonText: "Close"
            });
        }
    }

    async function saveName() {
        if (!userName || userName.length < 2) {
            AlertManager.show({
                type: "error", // "error", "warning", or "message"
                title: "Action failed",
                message: 'Please enter a valid name.',
                buttonText: "Close"
            });
            return;
        }

        const userId = localStorage.getItem("userUid");
        if (!userId) return;

        try {
            await firebase.database()
                .ref(`Users/${userId}`)
                .update({ name: userName });

            localStorage.setItem("userName", userName);

            setRecipientName(userName);

            setShowNameModal(false);
        } catch (err) {
            console.error(err);
            AlertManager.show({
                type: "error", // "error", "warning", or "message"
                title: "Action failed",
                message: 'Error updating name.',
                buttonText: "Close"
            });
        }
    }


return (
  <>
    <Header setPage={setPage} />
    <div className="contact-container">

    {loggedIn || nameId.length > 2 ? (
      <div className="contact-content">

        <div className="contact-width-wrapper">
          <div className="contact-card contact-card-settings">
            <div className="contact-header">

              <div className="contact-title-wrap">
                <h3 className="title-text">
                  <span className="settings-icon">⚙️</span>
                  {t("settings.title")}
                </h3>
                <p className="subtitle-text">
                  {t("settings.subtitle")}
                </p>
              </div>

              <div className="contact-user-wrap">
                <p className="user-info">✅ {t("settings.signedInAs")}</p>

                <span
                  key={recipientName}
                  className="user-name user-info-animate"
                >
                  {recipientName || t("settings.usernameFallback")}
                </span>

                <span
                  key={recipientEmail}
                  className="user-email-small user-info-animate"
                >
                  {recipientEmail}
                </span>
              </div>
            </div>

            <p className="manage-subscription" onClick={() => setShowNameModal(true)}>
              👤 {t("settings.updateName")}
            </p>

            <p className="manage-subscription" onClick={() => handleSettingsPress(nameId)}>
              🛠️ {t("settings.manageSubscription")}
            </p>

            <p className="manage-subscription" onClick={() => navigateTo('ai-chat')}>
              💬 {t("settings.chatWithAi")}
            </p>

            <p className="reset-password" onClick={ResetPasswordEmail}>
              ✏️ {t("settings.resetPassword")}
            </p>
            <button type="button" className="settings-delete-trigger" onClick={() => setShowDeleteModal(true)}>Delete your account?</button>

          </div>
        </div>
      </div>
    ) : (
      <div className="contact-card contact-card-guest">
        <div className="contact-header guest-header">
          <img
            src={logoNextStock}
            alt="Next Stock Logo"
            className="logo_contact"
          />
          <h2 className="guest-title">{t("settings.contactUs")}</h2>

          <button
            className="signin-btn"
            onClick={() => navigateTo("Signin")}
          >
            <LogIn size={16} />
            <span>{t("settings.signIn")}</span>
          </button>
        </div>

        <label>{t("settings.yourEmail")}</label>
        <input
          type="email"
          value={recipientEmail}
          onChange={(e) => setRecipientEmail(e.target.value)}
          placeholder={t("settings.enterEmail")}
        />
      </div>
    )}

    {loggedIn && <AppearanceSettings />}

    <div className="contact-card contact-card-message">
      <label>{t("settings.contactSupport")}</label>
      <input
        type="text"
        value={emailSubject}
        onChange={(e) => setEmailSubject(e.target.value)}
        placeholder={t("settings.subject")}
        className="input-subject"
      />

      <label>{t("settings.message")}</label>
      <textarea
        value={emailMessage}
        onChange={(e) => setEmailMessage(e.target.value)}
        placeholder={t("settings.messagePlaceholder")}
      />

      <button className="send-btn" onClick={sendMessage}>
        {t("settings.send")}
      </button>

      {success ? (
        <div className="success-message">
          <h3>{t("settings.thankYou")}</h3>
          <p>{t("settings.emailSent")}</p>
          <p>{t("settings.replySoon")}</p>
          <p>@ Next Stock team</p>
        </div>
      ) : (
        <p className="footer-text">@ Next Stock team</p>
      )}
    </div>

    {showNameModal && (
      <div className="name-modal-backdrop">
        <div className="name-modal-card">
          <button
            className="name-modal-close"
            onClick={() => setShowNameModal(false)}
          >
            ×
          </button>

          <h2 className="name-modal-title">{t("settings.updateName")}</h2>

          <p className="name-modal-subtitle">
            {t("settings.updateNameDescription")}
          </p>

          <input
            className="name-modal-input"
            type="text"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            placeholder={t("settings.enterYourName")}
          />

          <div className="name-modal-actions">
            <button
              className="name-modal-btn-secondary"
              onClick={() => setShowNameModal(false)}
            >
              {t("settings.cancel")}
            </button>

            <button
              className="name-modal-btn-primary"
              onClick={saveName}
            >
              {t("settings.save")}
            </button>
          </div>
        </div>
      </div>
    )}

    {showDeleteModal && <DeleteAccountModal email={recipientEmail} onClose={() => { sessionStorage.removeItem('nextstock:pending-account-deletion'); setShowDeleteModal(false); }} onSignInAgain={() => navigateTo('Signin')} />}
    <Footer />
    </div>
  </>
);

}
